/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_6_HInputs */

const en_terms_6_h = /** @type {(inputs: Terms_6_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our software`)
};

const id_terms_6_h = /** @type {(inputs: Terms_6_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perangkat lunak kami`)
};

/**
* | output |
* | --- |
* | "Our software" |
*
* @param {Terms_6_HInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_6_h = /** @type {((inputs?: Terms_6_HInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_6_HInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_6_h(inputs)
	return en_terms_6_h(inputs)
});